/**
 * 判断用户身份（平台、运营中心）
 */
import { getLocalStorage } from '@/assets/js/storage';

// 判断用户是否为总控平台用户
export const isPlat = () => {
    let boolean = false;
    if (getLocalStorage('auth')) {
        const type = JSON.parse(getLocalStorage('auth')).userInfo.accountType;
        if (type == 'ADMIN') {
            boolean = true;
        }
    }
    return boolean;
};

// 判断用户是否为运营中心用户
export const isOC = () => {
    let boolean = false;
    if (getLocalStorage('auth')) {
        const type = JSON.parse(getLocalStorage('auth')).userInfo.accountType;
        if (type == 'COMPANY') {
            boolean = true;
        }
    }
    return boolean;
};

export const isOnline = () => {
    return window.location.href.includes('http');
};
